import { createStore } from '@ngneat/elf';
import { withEntities } from '@ngneat/elf-entities';
import { GroupResult } from '@thiememeulenhoff/types';

export const groupResults = createStore(
  { name: 'groupResults' },
  withEntities<GroupResult, 'identifier'>({
    idKey: 'identifier',
  }),
);
